import './Checkbox.css';
import React, { useRef } from 'react';
import classnames from 'classnames';
import { FormField } from '../../../model/form';
import { t } from '../../../locales/translate';
import { useId } from '../../../util/react-util';

interface CheckboxBase extends FormField<boolean> {
  label?: React.ReactNode;
  required?: boolean;
  forceSpacing?: boolean;
  readOnly?: boolean;
  verticalAlign?: 'top' | 'middle' | 'bottom';
  description?: string | React.ReactNode;
}

export function FormCheckbox({
  inputId,
  value,
  label,
  required,
  readOnly,
  verticalAlign = 'middle',
  className,
  style,
  forceSpacing,
  errors,
  onChange,
  touched,
  valid,
  description,
}: CheckboxBase): JSX.Element {
  const inputRef: React.MutableRefObject<HTMLInputElement | null> = useRef(null);
  const displayErrors = touched && !valid;
  const id = useId(inputId);

  return (
    <div
      className={classnames(
        'check-box__container',
        `check-box__container--${verticalAlign}`,
        { 'check-box__container--force-spacing': forceSpacing },
        className
      )}
      style={style}
    >
      <input
        type="checkbox"
        className="check-box__input"
        id={id}
        checked={value || false}
        onChange={(e) => {
          if (!readOnly) {
            onChange?.(e.target.checked);
          }
        }}
        required={required}
        ref={inputRef}
      />
      {label && (
        <label className="check-box__label" htmlFor={id}>
          <span className="check-box__label-text">{label}</span>
          {displayErrors && <img className="check-box_label__alert" src="/icons/alert-circle.svg" alt="" />}
        </label>
      )}
      <div className="input__description-wrapper check-box__description">
        {description && <div className="input__description">{description}</div>}
        {displayErrors &&
          errors?.map((error) => {
            return (
              <div className="input__error-message" key={error}>
                {t.errors[error] || error}
              </div>
            );
          })}
      </div>
    </div>
  );
}
